export default __webpack_public_path__ + "static/media/videoButton.5b1e1a03.svg";